import { getAuth } from '../app/modules/auth/core/AuthHelpers'
import { useAuthorizationStore } from '../store/useAuthStore'
import { setUserProjects, setUserRoles } from './SessionStorageUtils'
import { investorApi } from '../api/investorApi'

export async function RefetchUserContext(): Promise<void> {
  try {
    const auth = getAuth()
    if (!auth) {
      return
    }

    const response = await investorApi.get('/auth/userContext', {
      headers: { 'Access-Control-Allow-Origin': '*', Authorization: auth },
    })

    const result = response.data

    if (result?.investorTypes) {
      const userAuthStore = useAuthorizationStore.getState()
      userAuthStore.setUserRoles(JSON.stringify(result.actions))
      userAuthStore.setUserInvestors(JSON.stringify(result.investorTypes))
      userAuthStore.setUserCompanies(JSON.stringify(result.userCompanies))

      sessionStorage.setItem('userCompanies', JSON.stringify(result.userCompanies))
      sessionStorage.setItem('userInvestors', JSON.stringify(result.investorTypes))
      sessionStorage.setItem('isAccountAdmin', result?.isAccountAdmin)
      sessionStorage.setItem('isSuperAdmin', result?.superAdmin ?? false)
      sessionStorage.setItem('datasets', JSON.stringify(result.datasets || []))

      setUserProjects('userProjects', result.projects)
      setUserRoles('userRoles', result.actions)
    }
  } catch (error) {
    console.error('Error refetching user context:', error)
    throw error
  }
}

export function useRefetchUserContext() {
  return {
    refetchUserContext: RefetchUserContext,
  }
}
